export default {
  FEEDBACK: 'Feedback'
}